import { Button, Grid, Paper, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FiltrosDetalle from "components/statistics/FiltrosDetalle";
import StatisticsDetailChart from "components/statistics/StatisticsDetailChart";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../../context/auth";
import Layout from "../common/Layout";


const StatisticsDetailView = () => {
  const [statsData, setStatsData] = React.useState([]);
  const { auth } = useAuth();
  const history = useHistory();
  const location = useLocation();

  const state = location.state || {};
  const category = state.category;
  const incomingFilter = state.filter || null;

  // Si se llega sin categoría (por ejemplo al refrescar la página, donde se
  // pierde el state de navegación) se regresa al módulo de estadísticas.
  React.useEffect(() => {
    if (!category) {
      history.replace("/estadistica");
    }
  }, [category, history]);

  function handleSetStatsData(data) {
    setStatsData(data);
  }

  if (!category) {
    return null;
  }

  return (
    <React.Fragment>
      <Layout headerTitle="Estadísticas">
        {[1, 2, 3].includes(auth.account.admin.role.id) ? (
          <Grid container justifyContent="center">
            <Grid item xs={12} style={{ display: "flex", alignItems: "center", padding: 8 }}>
              <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => history.push("/estadistica")}>
                Volver
              </Button>
              <Typography variant="h6" style={{ marginLeft: 16 }}>
                Categoría: {category}
              </Typography>
            </Grid>
            <FiltrosDetalle
              category={category}
              incomingFilter={incomingFilter}
              setStatsData={handleSetStatsData}
            />
            <Grid item xs={12}>
              <Paper style={{ overflow: "auto" }}>
                <StatisticsDetailChart data={statsData} />
              </Paper>
            </Grid>
          </Grid>
        ) : (
          "No tiene los privilegios requeridos"
        )}
      </Layout>
    </React.Fragment>
  );
};

export default StatisticsDetailView;
